import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { logError } from '../utils/log';

const AdminManageUserPage = () => {
  const { userId } = useParams();
  const [userDoc, setUserDoc] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const ref = doc(db, 'users', userId);
    const unsub = onSnapshot(ref, (snap) => {
      if (snap.exists()) {
        setUserDoc({ id: snap.id, ...snap.data() });
      } else {
        setUserDoc(null);
      }
      setLoading(false);
    }, (err) => {
      logError('Failed to fetch user', err);
      setUserDoc(null);
      setLoading(false);
    });
    return () => unsub();
  }, [userId]);

  if (loading) return <div className="spinner" aria-label="Loading" />;
  if (!userDoc) return <div className="text-center text-danger">User not found</div>;

  return (
    <div className="card p-4 rounded-lg shadow-md">
      <h2 className="page-title heading-primary-1 text-2xl font-bold mb-4">Manage User: {userDoc.nickname || userDoc.firstName || userDoc.email}</h2>
      <div className="space-y-2">
        <p><span className="text-muted">Email:</span> <span className="text-strong">{userDoc.email || 'N/A'}</span></p>
        <p><span className="text-muted">Role:</span> <span className="text-strong">{userDoc.role || (userDoc.isAdmin ? 'admin' : 'member')}</span></p>
        <p><span className="text-muted">Phone:</span> <span className="text-strong">{userDoc.phone || 'N/A'}</span></p>
        {/* Add edit controls here as needed */}
      </div>
    </div>
  );
};

export default AdminManageUserPage;
